import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  border: none;
  flex-flow: row wrap;
  height: auto;
  justify-content: center;
  margin: 1.5rem 0;
  outline: none;
  position: relative;
  display: flex;
  max-width: 32rem;
  width: 100%;

  @media (min-width: 36rem) {
    max-width: 100%;
    width: 32rem;
  }

  @media (min-width: 48rem) {
    max-width: 100%;
    width: 43.125rem;
  }

  @media (min-width: 62rem) {
    max-width: 100%;
    width: 27rem;
  }
`;

export const Title = styled.span`
  position: absolute;
  top: -1.5rem;
  left: 0;
  letter-spacing: 0.08rem;
  font-size: 0.875rem;
`;

export const CheckboxContainer = styled.div`
  width: 50%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  padding: 0.8125rem 0 0;
`;

export const CheckboxInput = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 0.25rem;
  background-color: ${({ checked }) => (checked ? '#007bfe' : '#dee2e6')};
  position: relative;

  &.focus {
    outline: 3px solid #b5d4f5;
  }
`;

export const CheckIcon = styled.div`
  width: 0.5rem;
  height: 0.3rem;
  border-bottom: 2px solid white;
  border-left: 2px solid white;
  transform: translate(-50%, -55%) rotate(-45deg);
  position: absolute;
  top: 45%;
  left: 50%;
  display: ${({ checked }) => (checked ? 'block' : 'none')};
`;

export const CheckboxLabel = styled.span`
  margin: 0 0.5rem;
  text-transform: capitalize;
`;
